// extracted by mini-css-extract-plugin
module.exports = {"block":"Divider_block__3rxGi","horizontal":"Divider_horizontal__1xcw9","default":"Divider_default__1jo7y"};